export class SapCompatMatrix {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "minimumContractVersion",
            "baseName": "minimumContractVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "maximumContractVersion",
            "baseName": "maximumContractVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "recommendedAgentVersion",
            "baseName": "recommendedAgentVersion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapCompatMatrix.attributeTypeMap;
    }
    constructor() {
    }
}
